import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { Brand } from 'type/rec'

type Props = {
  brand: Brand
}

export const BrandCheckbox = observer(({ brand }: Props) => {
  const item = store.item!
  const selected = item.rec.brand.selected(brand.name)

  const onClick = useLatestCallback(() => {
    item.rec.brand.toggle(brand.name)
  })

  return <Link action={onClick}>
    <Space minHeight={48} opposite>
      <Typo size={15} upper>
        {brand.title}
      </Typo>
      {selected && <Icon size={20} name="check" />}
    </Space>
  </Link>
})
